import "@/App.css";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import WhyUs from "@/components/WhyUs";
import PriceGuide from "@/components/PriceGuide";
import QuoteSection from "@/components/QuoteSection";
import Footer from "@/components/Footer";

function App() {
  useEffect(() => {
    document.documentElement.classList.add("dark");
  }, []);

  return (
    <div className="min-h-screen bg-zinc-950 text-white antialiased" data-testid="app-root">
      <Navbar />
      <main>
        <Hero />
        <Services />
        <WhyUs />
        <PriceGuide />
        <QuoteSection />
      </main>
      <Footer />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
